import { editBoard } from "frontend/services/boardsService";
import { useBoardValue } from "frontend/state/board-state";

export const useBoardTitle = () => {
  const [{ board }, dispatch] = useBoardValue();

  const changeBoardTitle = (title: string) => {
    if (!board) {
      return;
    }
    const newBoard = { ...board, name: title, updatedAt: new Date() };

    dispatch({ type: "set_board", payload: newBoard });
    editBoard(dispatch, newBoard, board).catch(() => {
      dispatch({ type: "set_board", payload: board });
    });
  };

  return [board?.name ?? "", changeBoardTitle] as const;
};
